class DashboardService {
    constructor(crudService, sharedPersistenceService, utilsService, storageService, gridsterPositions, $location, $stateParams) {
        this.crudService = crudService;
        this.utilsService = utilsService;
        this.storageService = storageService;
        this.gridsterPositions = gridsterPositions;
        this.REST_ENDPOINTS = sharedPersistenceService.getRestEndpoints();
        this.DASHBOARDS_REST = this.REST_ENDPOINTS.DASHBOARDS_REST;
        this.AUTHORITIES_REST = this.REST_ENDPOINTS.AUTHORITIES_REST;
        this.$location = $location;
        this.$stateParams = $stateParams;
    }

    getWidgets() {
        const size = { width: 1, height: 1 };
        if (this.gridsterPositions.getGridsterPoitions().length > 0) {
            let grid = this.gridsterPositions.getGridsterPoitions()
            return [
                { id: 'policies', position: { x: grid[0].position.x, y: grid[0].position.y }, size },
                { id: 'instances', position: { x: grid[1].position.x, y: grid[1].position.y }, size },
                { id: 'backups', position: { x: grid[2].position.x, y: grid[2].position.y }, size },
                { id: 'targets', position: { x: grid[3].position.x, y: grid[3].position.y }, size },
                { id: 'tasks', position: { x: grid[4].position.x, y: grid[4].position.y }, size },
                { id: 'events', position: { x: grid[5].position.x, y: grid[5].position.y }, size },
            ];
        }
        if (this.utilsService.isBackUpAdmin()) {
            return [
                { id: 'policies', position: { x: 0, y: 0 }, size },
                { id: 'instances', position: { x: 1, y: 0 }, size },
                { id: 'backups', position: { x: 2, y: 0 }, size },
                { id: 'targets', position: { x: 0, y: 1 }, size },
                { id: 'tasks', position: { x: 1, y: 1 }, size },
                { id: 'events', position: { x: 2, y: 1 }, size },
            ];
        } else {
            return [
                { id: 'policies', position: { x: 0, y: 0 }, size },
                { id: 'instances', position: { x: 1, y: 0 }, size },
                { id: 'backups', position: { x: 2, y: 0 }, size },
                { id: 'targets', position: { x: 0, y: 1 }, size },
                { id: 'tasks', position: { x: 1, y: 1 }, size },
                { id: 'events', position: { x: 2, y: 1 }, size },
            ];
        }
    }

    getDashboardData(isLogin) {
        return this.crudService.get(this.DASHBOARDS_REST, null, null, null, null, null, null, null, null, isLogin).then(response => {
            return response.data.entities;
        }).finally(() => {
            if(this.$stateParams.isLogin) {
                this.$stateParams['isLogin'] = null;
                this.$location.search({});
            }
        })

    }

    setIconClickState(widgetState, criteria, name, filterObj) {
        let state = widgetState;
        let obj = filterObj;
        return state + '(' + JSON.stringify(obj) + ')';
    }
}

DashboardService.$inject = ['crudService', 'sharedPersistenceService', 'utilsService', 'storageService', 'gridsterPositions', '$location', '$stateParams'];

module.exports = DashboardService;



// WEBPACK FOOTER //
// ./src/azurebackup/views/dashboard/dashboard.service.js